type HotjarCofigProps = {
  environment: string // "checkout" | "team-controls" | "development" | "production" etc.
}

/**
 * Custom React hook to inject Hotjar tracking script into the <head> of the document.
 */
function useHotjar() {
  /**
   * Inject Hotjar script into <head> of document
   */
  const initHotjar = ({ environment }: HotjarCofigProps) => {
    // only enable Hotjar for production env.
    if (environment !== 'production') return
    const siteId = 5238475
    const version = 6
    // Check if the script already exists to avoid duplicates
    if (document.getElementById('hotjar-script')) {
      console.warn('Hotjar script already injected.')
      return
    }

    // Create script/script element & append to head
    const scriptContent = `
      (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${siteId},hjsv:${version}};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `

    const script = document.createElement('script')
    script.id = 'hotjar-script'
    script.async = true
    script.innerHTML = scriptContent

    // Append the script to the head of the document
    document.head.appendChild(script)
  }

  /**
   * Remove Hotjar script from document.
   */
  const removeHotjar = () => {
    const hotjarScript = document.getElementById('hotjar-script')
    if (hotjarScript?.parentNode) {
      hotjarScript.parentNode.removeChild(hotjarScript)
    }
  }

  return {
    initHotjar,
    removeHotjar
  }
}

export default useHotjar
